module.exports = __webpack_public_path__ + "img/devices.73b6afca.png";